import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "moments",
        object: "moment",
        header: [
            { text: "ID", value: "id" },
            { text: "Type", value: "type" },
            { text: "Member", value: "member" },
            { text: "Name", value: "name" },
            { text: "Description", value: "description" },
            { text: "Date", value: "date" },
            { text: "Media", value: "media" },
            { text: "Actions", value: "actions", sortable: false },
        ],
    },
    mutations: {
        ...genericStore.mutations,
    },
    actions: {
        ...genericStore.actions,
    },
    getters: {
        ...genericStore.getters,
    },
};
